import api from '@/api';
import { PageResult } from '@/core/request/PageResult';
import {
  WorkOrderCommission,
  CreateWorkOrderCommissionRequest,
  ListWorkOrderCommissionByEmployeerRequest,
  AddManyWorkOrderCommission,
} from './WorkOrdersCommissions.types';

import { API_BASE_URL } from '..';
import { PageRequest } from '@/core/request/PageRequest';

const CONTROLLER_URL = `${API_BASE_URL}/workorders`;

export async function listWorkOrderCommissions(
  complementId?: number,
  itemId?: number,
  params?: PageRequest,
): Promise<PageResult<WorkOrderCommission>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/complements/${complementId}/Commissions/items/${itemId}`,
    params,
  )) as unknown;

  return result as PageResult<WorkOrderCommission>;
}

export async function createWorkOrderCommission({
  complementId,
  itemId,
  ...obj
}: CreateWorkOrderCommissionRequest): Promise<WorkOrderCommission> {
  const result = (await api.post(
    `${CONTROLLER_URL}/complements/${complementId}/Commissions/items/${itemId}`,
    obj,
    null,
  )) as unknown;

  return result as WorkOrderCommission;
}

export async function deleteWorkOrderCommission(
  complementId: number,
  itemId: number,
  employeeId: number,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/complements/${complementId}/Commissions/items/${itemId}/employees/${employeeId}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function listWorkOrderCommissionsByEmployeer(
  params: ListWorkOrderCommissionByEmployeerRequest,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/complements/${params.complementId}/Commissions/employees/${params.employeeId}`,
    { type: params.type },
  )) as unknown;

  return result as PageResult<WorkOrderCommission>;
}

export async function addManyWorkOrderCommissions(
  obj: AddManyWorkOrderCommission,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/complements/${obj.complementId}/Commissions/addmanycommission`,
    obj,
    null,
  )) as unknown;

  return result as void;
}
